// extracted by mini-css-extract-plugin
module.exports = {"onHoldContainer":"membershipbadge_onHoldContainer__ugXbi","obliqueLineWrap":"membershipbadge_obliqueLineWrap__36CbP","obliqueLine":"membershipbadge_obliqueLine__3hais"};